/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import '../style/scss/tablesimple.scss';

interface Model {
  name: string;
  id: number;
}

interface Props {
  models: Model[];
  onEdit: (id: number, name: string) => void; // Fonction pour gérer l'édition
}

const TableSimpleModel: React.FC<Props> = ({ models, onEdit }) => {
  const handleEdit = (id: number, name: string) => {
    onEdit(id, name);
    window.location.href = `/configuration/documents/modeles/modifier/${id}`;  };

  return (
    <table className="table align-middle mb-0 bg-white" id='tablesimple'>

      <thead className="bg-light">
      
        <tr>
          
          <th>Name</th>
          
          <th className='action'>Actions</th>
        
        </tr>
      
      </thead>

      <tbody>

        {models.map((model, index) => (

          <tr key={index}>

            <td>

              <div className="d-flex align-items-center">

                <div className="ms-3">

                  <p className="fw-bold mb-1">{model.name}</p>

                </div>

              </div>

            </td>

            <td className='edit'>
          
                <button
                  type="button"
                  onClick={() => handleEdit(model.id, model.name)}
                  className="btn btn-link btn-sm btn-rounded"
                  id="btntable"
                >

                  Modifier
                </button>
           
            </td>

          </tr>

        ))}

      </tbody>
      
    </table>
  );
};

export default TableSimpleModel;